module.exports = __webpack_public_path__ + "static/media/profile-placeholder.c897ae58.png";